import type { ResponseOf } from "@bsim/contracts";
import { useRoute } from "../api/context";

/** The bank at the start of round `roundNo` (`bankPosition`), cached under that round: a new round reads its own book, never the previous round's. */
export const useRoundPosition = (teamId: string, roundNo: number): ResponseOf<"bankPosition"> | undefined =>
  useRoute("bankPosition", { teamId }, { staleTime: Infinity, round: roundNo }).data;
